import LightWeightPayment from "../../Components/LightWeightCustomer/LightWeightPayment";

export default function LightWeightPayments(){
    return(
        <LightWeightPayment/>
    )
}